namespace $ { $mol_style_attach( "mol/lights/toggle/toggle.view.css",
 "[mol_lights_toggle] {\n\ttransform: rotate(-90deg);\n}\n"
) }